/**
 * Decodes a Google Routes API encoded polyline string into [lng, lat] pairs.
 * Implements the standard Polyline Algorithm so callers don't have to wait for
 * `window.google.maps.geometry` to load.
 *
 * @param {string} encoded - encoded polyline string from Google Routes API
 * @returns {[number, number][]} array of [lng, lat] coordinate pairs
 */
/* eslint-disable no-bitwise */
export const decodeEncodedPolyline = encoded => {
  if (typeof encoded !== 'string' || encoded.length === 0) return []
  const coords = []
  let index = 0
  let lat = 0
  let lng = 0
  while (index < encoded.length) {
    let shift = 0
    let result = 0
    let byte
    do {
      byte = encoded.charCodeAt(index) - 63
      index += 1
      result |= (byte & 0x1f) << shift
      shift += 5
    } while (byte >= 0x20)
    lat += result & 1 ? ~(result >> 1) : result >> 1

    shift = 0
    result = 0
    do {
      byte = encoded.charCodeAt(index) - 63
      index += 1
      result |= (byte & 0x1f) << shift
      shift += 5
    } while (byte >= 0x20)
    lng += result & 1 ? ~(result >> 1) : result >> 1

    coords.push([lng / 1e5, lat / 1e5])
  }
  return coords
}
/* eslint-enable no-bitwise */
